const initFlightRateOptionsManager = ()=>{
    const flightRateCollections = {};
    return {
        getFlightRateByRateId: (rateId)=>flightRateCollections[rateId],
        setFlightRates: (chatMessagesList)=>{
            const flightRatesOptionsMarkers = chatMessagesList.filter((m)=>m?.displayComponentName === 'FLIGHT_SEARCH_RESULTS_MARKER' && m?.markerComponentProps);
            flightRatesOptionsMarkers?.forEach(({ markerComponentProps })=>{
                const { searchResults } = markerComponentProps;
                searchResults?.forEach((flight)=>{
                    if (flight?.rateId) flightRateCollections[flight.rateId] = {
                        ...flight
                    };
                });
            });
        }
    };
};
const flightRateOptionsManager = initFlightRateOptionsManager();
export { flightRateOptionsManager, initFlightRateOptionsManager };
